import { calculateTotal } from './orderCalculations';

export const selectDonationTier = (donationState, amount) => ({
    ...donationState,
    selectedTier: amount,
    isCustom: false,
    customAmount: null
});

export const startCustomDonation = (donationState) => ({
    ...donationState,
    selectedTier: null,
    isCustom: true,
    customAmount: null
});

export const setDonationAmount = (order, amount) => {
    const updatedOrder = { ...order, donation: amount };
    return {
        ...updatedOrder,
        orderTotal: calculateTotal(updatedOrder)
    };
};
